import moment from 'moment-timezone'
export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{6,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)*(?::\d+)?((?:\/\w+)|(?:-\w+))*\/?(?![^<]*(?:<\/\w+>|\/?>))/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}
export const dateFormatValidator = (val, args) => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  return moment(val, args[0], true).isValid()
}
export const timeFormatValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  return moment(val, 'HH:mm', true).isValid()
}

export const notEmptyValidator = value => value.trim() !== ''

export const isValidCpf = (cpf, strictMode = false) => {
  if (!cpf) return false

  // Remove caracteres não numéricos
  const cleanCpf = cpf.replace(/\D/g, '')

  // Verifica se tem 11 dígitos
  if (cleanCpf.length !== 11) return false

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cleanCpf)) return false

  // Valida primeiro dígito verificador
  let sum = 0
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (10 - i)
  }
  let digit = 11 - (sum % 11)
  if (digit >= 10) digit = 0
  if (digit !== parseInt(cleanCpf.charAt(9))) return false

  // Valida segundo dígito verificador
  sum = 0
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (11 - i)
  }
  digit = 11 - (sum % 11)
  if (digit >= 10) digit = 0
  if (digit !== parseInt(cleanCpf.charAt(10))) return false

  return true
}

export const isValidCpnj = (cnpj, strictMode = false) => {
  if (!cnpj) return false

  // Remove caracteres não numéricos
  const cleanCnpj = cnpj.replace(/\D/g, '')

  // Verifica se tem 14 dígitos
  if (cleanCnpj.length !== 14) return false

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cleanCnpj)) return false

  // Valida primeiro dígito verificador
  let sum = 0
  let pos = 5
  for (let i = 0; i < 12; i++) {
    sum += parseInt(cleanCnpj.charAt(i)) * pos
    pos = pos === 2 ? 9 : pos - 1
  }
  let digit = sum % 11 < 2 ? 0 : 11 - (sum % 11)
  if (digit !== parseInt(cleanCnpj.charAt(12))) return false

  // Valida segundo dígito verificador
  sum = 0
  pos = 6
  for (let i = 0; i < 13; i++) {
    sum += parseInt(cleanCnpj.charAt(i)) * pos
    pos = pos === 2 ? 9 : pos - 1
  }
  digit = sum % 11 < 2 ? 0 : 11 - (sum % 11)
  if (digit !== parseInt(cleanCnpj.charAt(13))) return false

  return true
}

export const cpfValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return false;
  }
  return isValidCpf(val, true);
};
export const cnpjValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return false;
  }
  return isValidCpnj(val, true);
};
export const cnpjCpfValidator = val => {
  const doc = val.replaceAll(/\D/g, "");
  if (doc === undefined || doc === null || doc.length === 0) {
    return false;
  }
  if (doc.length === 14) {
    return isValidCpnj(doc, true);
  }
  if (doc.length === 11) {
    return isValidCpf(doc, true);
  }
  return false;
};
